import axios from 'axios'

export const fetchBankAccounts = async() => {
  try {
    return await axios.get(`bank-accounts`)
  } catch (error) {
    throw error.response
  }
}

export const fetchBankAccount = async(id) => {
  try {
    return await axios.get(`bank-accounts/${id}`)
  } catch (error) {
    throw error.response
  }
}
